document
  .querySelector('.individual_button')
  .addEventListener('click', function () {
    document.querySelector('.field_group_corporate').classList.add('hidden_SR');
    document.querySelector('.field_group_margin_bottom').classList.remove('mb');
    document
      .querySelectorAll('.company_name_required')
      .removeAttribute('required', '');
    document
      .querySelector('.previously_traded_required')
      .removeAttribute('required', '');
    document
      .querySelectorAll('.company_name_required')
      .setAttribute('disabled', '');
    document
      .querySelector('.previously_traded_required')
      .setAttribute('disabled', '');
  });
document
  .querySelector('.corporate_button')
  .addEventListener('click', function () {
    document
      .querySelector('.field_group_corporate')
      .classList.remove('hidden_SR');
    document.querySelector('.field_group_margin_bottom').classList.add('mb');
    document
      .querySelectorAll('.company_name_required')
      .setAttribute('required', '');
    document
      .querySelector('.previously_traded_required')
      .setAttribute('required', '');
    document
      .querySelectorAll('.company_name_required')
      .removeAttribute('disabled', '');
    document
      .querySelector('.previously_traded_required')
      .removeAttribute('disabled', '');
  });
